'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class;

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _catalog = require('redux/actions/catalog');

var _sliders = require('redux/actions/sliders');

var _sliders2 = require('redux/constants/sliders');

var _constants = require('redux/constants');

var _lodash = require('lodash');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Slide: {
        displayName: 'Slide'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Slide/Slide.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var timerId = void 0;

// Интервал автообновления списка слайдов
var SYNC_SLIDES_TIMEOUT = 1000 * 60 * 5;

var Slide = _wrapComponent('Slide')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{ promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        if (getState().setting.slider_novelty) {
            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_NEW));
        }return null;
    } }, { promise: function promise(_ref2) {
        var _ref2$store = _ref2.store,
            dispatch = _ref2$store.dispatch,
            getState = _ref2$store.getState;

        if (getState().setting.slider_hits) {
            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_HIT));
        }return null;
    } }, { promise: function promise(_ref3) {
        var _ref3$store = _ref3.store,
            dispatch = _ref3$store.dispatch,
            getState = _ref3$store.getState;

        if (getState().setting.slider_popular) {
            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_POPULAR));
        }return null;
    } }]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        settings: state.setting,
        sliders: state.sliders
    };
}, function (dispatch) {
    return {
        fetchProducts: function fetchProducts() {
            return [dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_NEW)), dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_HIT)), dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_POPULAR))];
        }
    };
}), _dec(_class = _dec2(_class = function (_Component) {
    (0, _inherits3.default)(Slide, _Component);

    function Slide() {
        (0, _classCallCheck3.default)(this, Slide);
        return (0, _possibleConstructorReturn3.default)(this, (Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).apply(this, arguments));
    }

    (0, _createClass3.default)(Slide, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.stopSync();
            this.startSync();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopSync();
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForContainer('Slide');
            var list = this.createSlidesList(this.props.settings, this.props.sliders);

            return _react3.default.createElement(
                'div',
                { className: 'Slide u-full-height' },
                _react3.default.createElement(_reactHelmet2.default, { title: '\u0421\u043B\u0430\u0439\u0434\u0435\u0440' }),
                _react3.default.createElement(View, { slidesList: list, updateProducts: this.props.fetchProducts })
            );
        }
    }, {
        key: 'startSync',
        value: function startSync() {
            var _this2 = this;

            timerId = setTimeout(function () {
                return _promise2.default.all(_this2.props.fetchProducts()), _this2.startSync();
            }, SYNC_SLIDES_TIMEOUT);
        }
    }, {
        key: 'stopSync',
        value: function stopSync() {
            clearTimeout(timerId);
        }

        // Проставляем для подуктов уникальные id-и
        // (для железности, если товар по ошибке продублируется в массиве 2-а раза,
        //  то будет ошибка при рендере)

    }, {
        key: 'createUniqueIdForEach',
        value: function createUniqueIdForEach(arrayItems, prefix) {
            if (Array.isArray(arrayItems)) {
                arrayItems.forEach(function (item) {
                    item.$uid = prefix + ':' + item.id;
                });
            }

            return arrayItems;
        }
    }, {
        key: 'createSlidesList',
        value: function createSlidesList() {
            var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var slides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var list = [];

            if (settings.slider_novelty && Array.isArray(slides.products_novelty)) {
                list = list.concat(this.createUniqueIdForEach(slides.products_novelty, _sliders2.SLIDER_NEW));
            }

            if (settings.slider_hits && Array.isArray(slides.products_hits)) {
                list = list.concat(this.createUniqueIdForEach(slides.products_hits, _sliders2.SLIDER_HIT));
            }

            if (settings.slider_popular && Array.isArray(slides.products_popular)) {
                list = list.concat(this.createUniqueIdForEach(slides.products_popular, _sliders2.SLIDER_POPULAR));
            }

            return list;
        }
    }]);
    return Slide;
}(_react2.Component)) || _class) || _class));

exports.default = Slide;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Slide/Slide.jsx
// module id = 1848
// module chunks = 0